
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import firebaseFunc from "../FirebaseService/FirebaseFunc";
import firebase from "../FirebaseService/FirebaseManager"
import { useAuthState } from "react-firebase-hooks/auth";

import styles from "./LogInComp.module.css"
// import "./Login.css";

function LogInComp(props) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [user, loading, error] = useAuthState(firebase.auth);
    const navigate = useNavigate();

    useEffect(() => {
        if (loading) {
            // maybe trigger a loading screen
            return;
        }
        if (user) {
            if (props.updateUserCallback)
                props.updateUserCallback(user)
            // console.log("Login", user)
            navigate(props.successNavigate);
        }

    }, [user, loading]);

    const loginOrRegister = (email, password) => {
        firebaseFunc.logInWithEmail(email, password).then(st => {
            console.log("Success")
        }).catch((err) => {
            console.log(err)
            firebaseFunc.registerWithEmail(email, password)
        })
    }

    return (
        <div className={styles.container}>
            <div className={styles.logInFormWrapper}>
                <input type="email"
                    className={styles.emailStyle} value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="E-mail Address"
                    required
                />
                <input
                    type="password"
                    className={styles.passwordStyle} value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    required
                />
                <button
                    className={styles.logInBtnStyle}
                    onClick={() => loginOrRegister(email, password)}
                >
                    Sign in/Sign Up
                </button>
                <button className={styles.logInWithGoogleBtnStyle} onClick={firebaseFunc.signInWithGoogle}>
                    Login with Google
                </button>
                <button className={styles.logOutBtnStyle} onClick={firebaseFunc.logOut}>
                    Logout
                </button>
            </div>
        </div>
    );
}
export default LogInComp;